import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=e28d36ac&"
import script from "./MyTable.vue?vue&type=script&lang=js&"
export * from "./MyTable.vue?vue&type=script&lang=js&"
import style0 from "./MyTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports